/**
 * Users API service
 */
export class UsersApi {
  constructor(apiClient) {
    this.client = apiClient;
  }

  /**
   * Get current user info
   */
  getMe() {
    return this.client.get('/users/me');
  }

  /**
   * Update current user info
   */
  updateMe(payload) {
    return this.client.patch('/users/me', payload);
  }

  /**
   * Login with Google (exchange authorization code for tokens)
   */
  loginWithGoogle(code, redirectUri) {
    return this.client.post('/google', { code, redirect_uri: redirectUri });
  }

  /**
   * Logout (clear refresh token on server)
   */
  logout() {
    return this.client.post('/auth/logout');
  }

  /**
   * Refresh auth token
   */
  refreshToken() {
    return this.client.post('/auth/refresh');
  }
}

export default UsersApi;
